/* eslint-disable no-unused-vars */
import { Button, Input, InputNumber, Modal, Select, Spin, message } from 'antd'
import { wind2PerformanceUpdate } from 'api/pgads'
import { ErrorContext, JcTmpErrorContext, SpinContext } from 'context'
import { monthsMap } from 'core'
import JcTmpErrorDialog, {
  isErrorContains,
} from 'core/component/JcTmpErrorDialog'
import { Label } from 'core/screen-util'
import React, { useContext, useMemo, useState } from 'react'
import { getPermitActions } from '../core/selectors'
import { connect } from 'react-redux'
import { WIND_ADMIN_POWER_DATA_20 } from '../core/EventActions'
import { hasAccesPermits } from 'core/utils'

const Wind2PerformanceDialog = ({
  data,
  targetInfo,
  visible,
  onHide = _ => _,
  onRetrieve,
  isNew = false,
  avalibilityStatusIdMap,
  avaliablitilityStatusList,
  actionPermits,
}) => {
  const { spinning, setSpinning } = useContext(SpinContext)
  const { setError } = useContext(ErrorContext)
  const [insertData, setInsertData] = useState(data)
  const { setTmpError } = useContext(JcTmpErrorContext)

  const hasWindPowerDataWritePermission = useMemo(
    _ =>
      hasAccesPermits({
        actionPermits,
        eventActions: [WIND_ADMIN_POWER_DATA_20],
        matchAny: true,
      }),
    [actionPermits]
  )
  const onSave = _ => {
    setSpinning(true)
    wind2PerformanceUpdate(targetInfo)([insertData]).fork(
      setError,
      errorList => {
        setSpinning(false)
        setTmpError(errorList)
        if (!isErrorContains(errorList)) {
          message.info('Data saved.')
          onHide()
          onRetrieve()
        }
      }
    )
  }

  return (
    <Modal
      onCancel={onHide}
      visible={visible}
      footer={
        <div>
          <div>
            {hasWindPowerDataWritePermission && (
              <Button type="primary" onClick={onSave}>
                Save{' '}
              </Button>
            )}
            <Button onClick={onHide}>Cancel</Button>
          </div>
        </div>
      }
      centered
      height={400}
      width={1200}
      title={<div>NERC Performance Data : {insertData.subgroupName}</div>}
    >
      <Spin spinning={spinning}>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '230px  130px 200px 100px 200px 100px',
            gap: 5,
            width: 1000,
          }}
        >
          <Label>Subgroup Status :</Label>
          <Select
            value={insertData.status}
            onChange={status => setInsertData({ ...insertData, status })}
          >
            {avaliablitilityStatusList.map(
              ({ avaliabilityStatusCode, avaliabilityStatusName }) => (
                <Select.Option
                  value={avaliabilityStatusCode}
                  key={avaliabilityStatusCode}
                >
                  {avaliabilityStatusName}
                </Select.Option>
              )
            )}
          </Select>
          <Label>Net Max Capacity (MW) :</Label>
          <InputNumber
            value={insertData.netmaxcap}
            onChange={netmaxcap => setInsertData({ ...insertData, netmaxcap })}
          />
          <Label>Period (Active) THrs :</Label>
          <InputNumber
            value={insertData.activeThrs}
            onChange={activeThrs =>
              setInsertData({ ...insertData, activeThrs })
            }
          />

          <Label>Gross Actual Generation (MWh) :</Label>
          <InputNumber
            value={insertData.grossactgen}
            onChange={grossactgen =>
              setInsertData({ ...insertData, grossactgen })
            }
          />
          <Label>Net Actual Generation (MWh) :</Label>
          <InputNumber
            value={insertData.netactgen}
            onChange={netactgen => setInsertData({ ...insertData, netactgen })}
          />
          <Label>Expected Generation (MWh) :</Label>
          <InputNumber
            value={insertData.expectedGen}
            onChange={expectedGen =>
              setInsertData({ ...insertData, expectedGen })
            }
          />

          <Label>Contact THrs :</Label>
          <InputNumber
            value={insertData.contactThrs}
            onChange={contactThrs =>
              setInsertData({ ...insertData, contactThrs })
            }
          />
          <Label>Reserve Shutdown THrs :</Label>
          <InputNumber
            value={insertData.rsThrs}
            onChange={rsThrs => setInsertData({ ...insertData, rsThrs })}
          />
          <Label>Resource Unavailable THrs :</Label>
          <InputNumber
            value={insertData.ruThrs}
            onChange={ruThrs => setInsertData({ ...insertData, ruThrs })}
          />

          <Label>Forced THrs :</Label>
          <InputNumber
            value={insertData.forcedThrs}
            onChange={forcedThrs =>
              setInsertData({ ...insertData, forcedThrs })
            }
          />
          <Label>Maintenance THrs :</Label>
          <InputNumber
            value={insertData.maintenanceThrs}
            onChange={maintenanceThrs =>
              setInsertData({ ...insertData, maintenanceThrs })
            }
          />
          <Label>Planned THrs :</Label>
          <InputNumber
            value={insertData.plannedThrs}
            onChange={plannedThrs =>
              setInsertData({ ...insertData, plannedThrs })
            }
          />

          <Label>Retired THrs :</Label>
          <InputNumber
            value={insertData.retiredThrs}
            onChange={retiredThrs =>
              setInsertData({ ...insertData, retiredThrs })
            }
          />
          <Label>Inactive Reserve THrs :</Label>
          <InputNumber
            value={insertData.inactiveReserveThrs}
            onChange={inactiveReserveThrs =>
              setInsertData({ ...insertData, inactiveReserveThrs })
            }
          />
          <Label>Mothballed THrs :</Label>
          <InputNumber
            value={insertData.mothballedThrs}
            onChange={mothballedThrs =>
              setInsertData({ ...insertData, mothballedThrs })
            }
          />
        </div>
      </Spin>
    </Modal>
  )
}

const mapStateToProps = state => ({
  // eventTypes: getEventTypes(state),
  actionPermits: getPermitActions(state),
})

export default connect(mapStateToProps)(Wind2PerformanceDialog)
